import React, { forwardRef, useImperativeHandle } from 'react';

import * as General from '../General/General';
import * as rsuite from 'rsuite';
import axios from 'axios';
import { trackPromise } from 'react-promise-tracker';


const Auto_User = forwardRef((props, ref) => {

    const toaster = rsuite.useToaster();

    const [List, setList] = React.useState([]);
    const Select = (event) => {
        props.onSelect(event)
    }

    const Change = (event) => {
        props.onChange(event)
    }
    useImperativeHandle(ref, () => ({

        BindSupplier(search) {
            var RequestOptions = {
                data: {
                    'IsActive': 1,
                    'FullName': search

                },
                url: General.ApiRoute() + "/User/SearchSupplier",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",
                                lable: result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",


                            })
                        }
                        setList(tmp)
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        },
        BindCoWorker(search) {

            var RequestOptions = {
                data: {
                    'IsActive': 1,
                    'FullName': search
                },
                url: General.ApiRoute() + "/User/SearchCoworker",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        console.dir(result.data)
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",
                                lable: result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",


                            })
                        }
                        setList(tmp)
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        },
        GetByMobile(search) {
            var RequestOptions = {
                data: {
                    'IsActive': 1,
                    'FullName': search

                },
                url: General.ApiRoute() + "/User/SearchByMobile",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")|" + result.data[i].financialBalance
                                    + "|" + result.data[i].mobile + "|" + result.data[i].address + "|" + result.data[i].cityId,
                                lable: result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",


                            })
                        }
                        setList(tmp)
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        },
        GetByMobile_Customer(search) {
            var RequestOptions = {
                data: {
                    'IsActive': 1,
                    'FullName': search

                },
                url: General.ApiRoute() + "/User/SearchByMobile_Customer",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")|" + result.data[i].financialBalance
                                    + "|" + result.data[i].mobile + "|" + result.data[i].address + "|" + result.data[i].cityId,
                                lable: result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",


                                // setCustomer(e.split("|")[1]);
                                // setCustomerId(e.split("|")[0]);
                                // setFinancialBalance(e.split("|")[2] * 1 > 0);
                                // setMobile(e.split("|")[3]);
                                // setAddress(e.split("|")[4]);
                                // setCityId(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)
                                // CityRef.current.Select(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)

                            })
                        }
                        setList(tmp)
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        },

        GetForAuto_Total(search, IsCustomer, IsCoWorker, IsSupplier) {
            var RequestOptions = {
                data: {
                    'FullName': search,
                    'IsCustomer': IsCustomer,
                    'IsCoWorker': IsCoWorker,
                    'IsSupplier': IsSupplier

                },
                url: General.ApiRoute() + "/User/SearchForAuto",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }


            trackPromise(
                axios(RequestOptions)
                    .then(function (result) {
                        var tmp = []
                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                value: result.data[i].id + "|" + result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")|" + result.data[i].financialBalance
                                    + "|" + result.data[i].mobile + "|" + result.data[i].address + "|" + result.data[i].cityId,
                                lable: result.data[i].firstName + " " + result.data[i].lastName + " (" + result.data[i].mobile + ")",


                                // setCustomer(e.split("|")[1]);
                                // setCustomerId(e.split("|")[0]);
                                // setFinancialBalance(e.split("|")[2] * 1 > 0);
                                // setMobile(e.split("|")[3]);
                                // setAddress(e.split("|")[4]);
                                // setCityId(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)
                                // CityRef.current.Select(e.split("|")[5] != -1 ? e.split("|")[5] * 1 : 0)

                            })
                        }
                        setList(tmp)
                    }).catch((error) => {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                    })
            )

        },
        focus() {
            const inputElement = document.querySelector('.FocusAutoComplete input');
            if (inputElement) {
                inputElement.focus();
            }
        }
    }),
        [props.value])

    return (
        <rsuite.AutoComplete
            data={List.map((product) => ({
                label: `${product.lable}`,
                value: `${product.value}`,
            }))}
            value={props.value}
            label={props.lable}
            onChange={Change}
            onSelect={Select}
            disabled={props.disabled}
            className='FocusAutoComplete'

        />)
});

export default Auto_User;